import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';
import { Col } from '../../../base/Grid';
import Typography from '../../../base/Typography';
import Picture from '../../../base/Picture';

export const PhotoCol = styled(Col)`
&& {
  ${({ theme }) => {
    const mobile = theme.useMediaQuery(theme.breakpoints.down('medium'));
    return css`
      margin-bottom: ${mobile ? rem(24) : 0};
      padding-right: ${mobile ? 0 : rem(32)};
      display: flex; 
      justify-content: center;
    `;
  }}
}
`;

export const TypographyHeadlineStyled = styled(Typography)`
&& {
  ${({ theme }) => {
    const mobile = theme.useMediaQuery(theme.breakpoints.down('medium'));
    return css`
      text-align: ${mobile ? 'center' : 'left'};
    `;
  }}
}
`;

export const DivButtonContainer = styled.div`
&& {
  ${({ theme }) => {
    const mediumDown = theme.useMediaQuery(theme.breakpoints.down('medium'));
    const smallDown = theme.useMediaQuery(theme.breakpoints.down('small'));
    return css`
      text-align: ${mediumDown ? 'center' : 'left'};
      ${smallDown && css`
        button { width: 100%; max-width: 100%; }
      `}
      margin-top: ${rem(12)};
    `;
  }}
}
`;

export const PictureFRPhotoStyled = styled(Picture)`
  ${({ theme }) => {
    const mediumUp = theme.useMediaQuery(theme.breakpoints.up('medium'));
    const smallUp = theme.useMediaQuery(theme.breakpoints.up('small'));
    let horizontalPadding = rem(30);

    if (mediumUp) {
      horizontalPadding = 0;
    } else if (smallUp) {
      horizontalPadding = rem(70);
    }

    return css`
      padding: 0 ${horizontalPadding};
      display:block;
    `;
  }}
`;
